import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getSettingsRequest = {};
var _getSettingsResponse = {};
var _updateSettingsRequest = {};
var _updateSettingsResponse = {};
function resolveComWixpressMembershipV2SettingsSettingsServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'forums.wixapps.net': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
            {
                srcPath: '/paid-plans/v1/orders',
                destPath: '/v1/orders',
            },
        ],
        '*.wixapps.net': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
            {
                srcPath: '/_api/pricing-plans',
                destPath: '',
            },
        ],
        'forums._base_domain_': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/membership-api',
                destPath: '',
            },
            {
                srcPath: '/paid-plans',
                destPath: '',
            },
            {
                srcPath: '/_api/paid-plans',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function updateSettings(payload) {
    var _a = serializer(_updateSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSettingsResponse, {}).fromJSON;
    function __updateSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.settings',
            method: 'PATCH',
            methodFqn: 'com.wixpress.membership.v2.settings.SettingsService.UpdateSettings',
            url: resolveComWixpressMembershipV2SettingsSettingsServiceUrl({
                protoPath: '/v2/settings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSettings.fromReq = fromReq;
    __updateSettings.__isAmbassador = true;
    return __updateSettings;
}
export function getSettings(payload) {
    var _a = serializer(_getSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSettingsResponse, {}).fromJSON;
    function __getSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.settings',
            method: 'GET',
            methodFqn: 'com.wixpress.membership.v2.settings.SettingsService.GetSettings',
            url: resolveComWixpressMembershipV2SettingsSettingsServiceUrl({
                protoPath: '/v2/settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSettings.fromReq = fromReq;
    __getSettings.__isAmbassador = true;
    return __getSettings;
}
//# sourceMappingURL=http.impl.js.map